<template>
    <div class="py-3 text-center">
        <b-link
            :to="`/v2/strategy/link-okr/linked?onepageId=${queryParams.onepageId}&blockId=${queryParams.blockId}&attributeId=${queryParams.attributeId}`"
            class="links mr-3"
            active-class="link-active"
        >
            {{ $tc('strategy.okrs.linked', 2) }}
        </b-link>
        <b-link
            :to="`/v2/strategy/link-okr/list?onepageId=${queryParams.onepageId}&blockId=${queryParams.blockId}&attributeId=${queryParams.attributeId}`"
            class="links"
            active-class="link-active"
        >
            {{ $t('strategy.okrs.list') }}
        </b-link>
    </div>
</template>

<script>
export default {
    name: 'Links',
    props: {
        queryParams: {
            type: Object,
            required: true,
        },
    },
}
</script>

<style lang="scss" scoped>
.links {
    color: #6e6e6e;
    font-weight: 600;
    font-size: 1.2rem;
    text-decoration: none;
}
.link-active {
    color: #009ada;
    border-bottom: 2px solid #009ada;
}
</style>
